import moment from "moment";

export const validateDate = (date) => moment(date).isValid();

export const validateMomentUnit = (momentUnit) => {
  if (
    momentUnit !== "days" &&
    momentUnit !== "weeks" &&
    momentUnit !== "months" &&
    momentUnit !== "years"
  ) {
    throw new Error("Invalid moment unit provided to validateMomentUnit util");
  }
};

export const isDateExactlySame = (date1, date2) => {
  if (!validateDate(date1) || !validateDate(date2)) {
    throw new Error("Invalid input provided to isDateExactlySame util");
  }

  return moment(date1).isSame(date2);
};

export const getDateRange = (startDate, endDate, momentUnit = "days") => {
  // Validate momentUnit

  validateMomentUnit(momentUnit);

  // Invalid date OR Start date falls after end date

  if (
    !validateDate(startDate) ||
    !validateDate(endDate) ||
    moment(startDate).isAfter(endDate)
  ) {
    return [];
  }

  // Start date and end date are the same

  if (isDateExactlySame(startDate, endDate)) return [startDate];

  // Start date and end date are different

  const dates = [];

  let currentDate = moment(startDate);

  do {
    dates.push(currentDate.format("YYYY-MM-DD"));

    currentDate = currentDate.add(1, momentUnit);
  } while (currentDate.isSameOrBefore(endDate));

  return dates;
};

export const getStartDate = (
  endDate,
  momentUnit = "days",
  momentUnitCount = 1
) => {
  // Validate momentUnit

  validateMomentUnit(momentUnit);

  if (
    !validateDate(endDate) ||
    momentUnitCount < 1 ||
    typeof momentUnitCount !== "number"
  ) {
    throw new Error(
      "Invalid input provided to getStartDate util. Check endDate validity and ensure momentUnitCount is a positive number"
    );
  }

  return moment(endDate)
    .subtract(momentUnitCount, momentUnit)

    .format("YYYY-MM-DD");
};

export const formatDate = (date, formatDate = "MM/DD/YYYY") => {
  if (!validateDate(date)) {
    return date;
  }

  return moment(date).format(formatDate);
};
